
import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { IRtmTemplateRes } from './index.type';
// perpageData: number
// , perpageData

const useAllTemplate = ({ page,searchKey,status,type,sort,order}: { page: number; searchKey:string;type:string,status:string,sort?: string,order?: 'asc' | 'desc'; }) => {
  const [templateData, setTemplateData] = React.useState<IRtmTemplateRes>();
  
  const { loading: templateDataLoading, makeApiCall } = useApi({
    url: `/rtm/template?search=${searchKey}&status=${status}&type=${type}&page=${page}&sort=${sort || ''}&order=${order || ''}`,
    method: 'GET',
  });

  const getTemplateData = async () => {
    const { response, error } = await makeApiCall<undefined,IRtmTemplateRes>();
    if (response?.status === 'success') {
        setTemplateData(response);
    }

    if (response?.status === 'fail') {
        setTemplateData(undefined);
    }

    if (error) toast.error('Something went wrong while fetching clinic data. Please try again later');
  };

  return {
    templateData,
    getTemplateData,
    templateDataLoading,
  };
};

export default useAllTemplate;
